import { GlobalPositionStrategy } from '@angular/cdk/overlay';

export class NotificationsPositionStrategy extends GlobalPositionStrategy {
  public apply() {
    super.apply();
    const element = this['_overlayRef'].overlayElement;
    element.style.justifyContent = this['_overlayRef'].hostElement.style.justifyContent;
    element.style.alignItems = this['_alignItems'];
    element.style.display = 'flex';
    element.style.width = '100%';
    element.style.height = '100%';
  }
}
